import { Box } from '@mui/material';
import React from 'react';
import BaseTypography from 'components/typography/BaseTypography';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import { landingPageStyles } from 'layouts/pages/landing-page/landingPageStyles';
import CharactersClothingVideos from './components/CharactersClothingVideos';
import { clothingSectionStyles } from './clothingSectionStyles';

export default function CharactersClothingSection() {
	return (
		<Box id="characters-clothing-section" sx={[clothingSectionStyles.mainContainer]}>
			<Box sx={[reusableStyles.flexRow, { width: { xs: '100%', mobileUi: '35%', xxl: '45%' } }]}>
				<Box
					id="characters-clothing-description"
					sx={[landingPageStyles.sectionDescriptionContainer]}
				>
					<BaseTypography
						variant="h2_zodiak"
						styles={{ color: 'colors.light3', textAlign: 'left' }}
					>
						Dress Your AI Characters and Showcase Your Fashion.
					</BaseTypography>
					<BaseTypography
						variant="b2_regular"
						styles={{
							color: 'colors.light3',
							fontSize: { xl: '14px' },
							lineHeight: { xl: '24px' },
						}}
					>
						Showcase your clothing line with AI characters styled in your designs — perfect for
						Ecommerce, Shopify, and fashion marketing.
					</BaseTypography>
				</Box>
			</Box>
			<CharactersClothingVideos />
		</Box>
	);
}
